import { CreditBalances } from '../api/api';
import { Actions } from './Actions';
import { type CreditAccount } from './CreditAccount';
import { emptyPaymentAccount, type PaymentAccount } from './PaymentAccount';
import { ProductAccount } from './ProductAccount';
import { emptyUserInformation, UserInformation } from './UserInformation';

export interface LoadHomeResponse {
  userInformation: UserInformation;
  creditBalances?: CreditBalances;
  primaryPaymentAccount: PaymentAccount;
  productAccounts: ProductAccount[];
  actions: Actions[];
  hasCreditCard: boolean;
  hasSpendCard: boolean;
  creditAccount?: CreditAccount;
}

export const initialLoadHomeResponse: LoadHomeResponse = {
  userInformation: emptyUserInformation,
  primaryPaymentAccount: emptyPaymentAccount,
  productAccounts: [],
  actions: [],
  hasCreditCard: false,
  hasSpendCard: false,
};
